// П-1 (встреча 22.10.2026): задача смены закрывается только через подтверждение — случайный щелчок по галочке
// больше не снимает задачу. Поле «Результат» необязательное: что сделали, с кем договорились.

import { useState } from "react";
import { fmtDateTime } from "../../shared/format";
import { Button, Field, Modal, useToast } from "../../shared/ui";
import { api } from "../ctx";

export type TaskRow = { id: string; title: string; status: string; result?: string | null; done_by?: string | null; done_at?: string | null };

export function CloseTaskDialog({ task, onClose, onDone }: { task: TaskRow; onClose: () => void; onDone: () => void }) {
  const toast = useToast();
  const [result, setResult] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/tasks/${task.id}`, { status: "done", result: result.trim() || null });
      toast.ok("Задача закрыта");
      onDone();
    } catch (e) {
      toast.error(e);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal title="Закрыть задачу?" onClose={onClose} actions={<>
      <Button onClick={onClose}>Не закрывать</Button>
      <Button variant="primary" disabled={busy} onClick={save}>Закрыть задачу</Button>
    </>}>
      <p style={{ marginTop: 0 }}><b>{task.title}</b></p>
      <Field label="Результат" hint="Необязательно: что сделали, с кем договорились. Будет видно в истории смен.">
        <textarea className="input" rows={3} autoFocus value={result} onChange={(e) => setResult(e.target.value)} placeholder="Например: прораб подтвердил 14:00" />
      </Field>
    </Modal>
  );
}

/** Строка «закрыта: Иванова, 23.10 14:05 — прораб подтвердил 14:00». */
export function TaskDone({ t }: { t: TaskRow }) {
  if (t.status !== "done") return null;
  return (
    <div className="small muted">
      закрыта{t.done_by ? `: ${t.done_by}` : ""}{t.done_at ? `, ${fmtDateTime(t.done_at)}` : ""}{t.result ? ` — ${t.result}` : ""}
    </div>
  );
}
